import { DndContext, DragEndEvent, DragStartEvent, closestCenter } from '@dnd-kit/core'
import {
  SortableContext,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable'
import { FormattedMenuSectionInfo } from 'api'
import React, { ReactNode, useState } from 'react'

interface Props {
  customizationGroups: FormattedMenuSectionInfo[]
  onCustomizationGroupsReorder: (newCustomizationGroups: FormattedMenuSectionInfo[]) => void
  children: ReactNode
  isPrinterClient?: boolean
}

const SortableModifierGroupContainer = ({
  customizationGroups,
  onCustomizationGroupsReorder,
  children,
  isPrinterClient,
}: Props) => {
  const [isAnyGroupDragging, setIsAnyGroupDragging] = useState(false)

  const handleDragStart = (_event: DragStartEvent) => {
    setIsAnyGroupDragging(true)
  }

  const handleDragEnd = (event: DragEndEvent) => {
    setIsAnyGroupDragging(false)
    
    const { active, over } = event

    if (!over || active.id === over.id) {
      return
    }

    const oldIndex = customizationGroups.findIndex((item) => item.id === active.id)
    const newIndex = customizationGroups.findIndex((item) => item.id === over.id)

    if (oldIndex === -1 || newIndex === -1) {
      return
    }

    const newCustomizationGroups = [...customizationGroups]
    const [movedItem] = newCustomizationGroups.splice(oldIndex, 1)
    newCustomizationGroups.splice(newIndex, 0, movedItem)

    onCustomizationGroupsReorder(newCustomizationGroups)
  }

  // Only enable sorting for printer clients (Epson POS)
  if (!isPrinterClient) {
    return <>{children}</>
  }

  return (
    <DndContext 
      collisionDetection={closestCenter} 
      onDragStart={handleDragStart}
      onDragEnd={handleDragEnd}
    >
      <SortableContext items={customizationGroups.map((item) => item.id)} strategy={verticalListSortingStrategy}>
        {React.Children.map(children, (child) => {
          if (React.isValidElement(child)) {
            return React.cloneElement(child, { isAnyGroupDragging } as any)
          }
          return child
        })}
      </SortableContext>
    </DndContext>
  )
}

export default SortableModifierGroupContainer 